import React from 'react';
import { Link } from 'react-router-dom'
import { Sparklines, SparklinesLine } from 'react-sparklines';

export default function StatLegend({ color, value, value_secondary, label, sparkline_data }) {

    return (
        <div class="card" style={{ backgroundColor: color, paddingLeft: "10px" }}>
            <div class="card-content">
                <div class="columns">
                    {sparkline_data && <div class="column">
                        <Sparklines data={sparkline_data}>
                            <SparklinesLine style={{ fill: "white" }} color="white" />
                        </Sparklines>
                    </div>}
                    <div class="column">

                        <p className="sub-title has-text-white  is-size-6">{label}</p>
                        <p className="title has-text-white is-size-4"> {value}
                            {value_secondary !== undefined && value_secondary.length > 0 &&

                                <span className="has-text-white is-size-6"> ({value_secondary})</span>
                            }
                        </p>

                    </div>
                </div>
            </div>
        </div>
    );
}


// WEBPACK FOOTER //
// ./src/components/stat.js